import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-459b8f5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "任务详情", -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "btn-toolbar mb-2" }
const _hoisted_5 = { class: "btn-group" }
const _hoisted_6 = { class: "input-group ms-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "线程数")
], -1))
const _hoisted_8 = { class: "list-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaskComp = _resolveComponent("TaskComp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeWorkerStatus && _ctx.changeWorkerStatus(...args))),
            class: "btn btn-dark"
          }, _toDisplayString(_ctx.isRunning ? '停止' : '启动') + "下载线程 ", 1),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.autoRetryAll && _ctx.autoRetryAll(...args))),
            class: "btn btn-dark"
          }, _toDisplayString(_ctx.isRetring ? '关闭' : '自动') + "重试错误片段 ", 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: "form-control",
            min: "1",
            style: {"width":"70px"},
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.workerCount) = $event)),
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.adjustWorkerCount && _ctx.adjustWorkerCount(...args)))
          }, null, 544), [
            [_vModelText, _ctx.workerCount]
          ])
        ])
      ]),
      _createElementVNode("ul", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskList, (task) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "list-group-item",
            key: task.id
          }, [
            _createVNode(_component_TaskComp, {
              task: task,
              manager: _ctx.manager,
              remove: _ctx.remove
            }, null, 8, ["task", "manager", "remove"])
          ]))
        }), 128))
      ])
    ])
  ]))
}